import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedMembershipRoute({ children }) {
  const navigate = useNavigate();
  const { user, initialized, hasActiveSubscription } = useAuth();

  // 🧠 1. Esperar a que cargue
  if (!initialized) {
    return null;
  }

  // 🔒 2. No autenticado
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 🧠 3. ADMIN / STAFF siempre pueden entrar
  if (user.role === "ADMIN" || user.role === "STAFF") {
    return children;
  }

  // 🔒 4. Usuario sin membresía activa
  if (!hasActiveSubscription) {
    return (
      <main className="z-access-paused-shell">
        <section className="z-access-paused-card">
          <div className="z-access-paused-kicker">
            Membresía pausada
          </div>

          <h1 className="z-access-paused-title">
            ¡No detengas tu evolución en ZEDRO!
          </h1>

          <p className="z-access-paused-copy">
            Tu membresía ha expirado, pero tu historial está 100% a salvo.
             Puedes retomar tu formación en cualquier momento sin perder ni un solo paso de tu avance.
          </p>

          <p className="z-access-paused-note">
            ZEDRO está diseñado para acompañarte paso a paso, con orden, constancia y profundidad.
          </p>

          <div className="z-access-paused-actions">
            <button
              type="button"
              className="z-access-paused-primary"
              onClick={() => navigate("/store")}
            >
              Reactivar mi membresía
            </button>
          </div>
        </section>
      </main>
    );
  }

  // ✅ 5. Acceso permitido
  return children;
}